import type { ErrorFallbackProps } from "@circle-react-shared/ErrorBoundary";
import { Button } from "@circleco/compass/components/Button";
import { Icon } from "@circleco/compass/components/Icon";
import { Typography } from "@circleco/compass/components/Typography";

import { t } from "@/i18n-js/instance";

export const CommentsErrorFallback = ({
  error,
  resetState,
}: ErrorFallbackProps) => (
  <div className="flex flex-col items-center gap-3 py-6 text-center">
    <Icon name="triangle-exclamation-filled" color="danger" size="lg" />
    <Typography variant="heading-md" color="primary">
      {t("comments.error_boundary.title")}
    </Typography>
    <Typography variant="body-sm" color="secondary">
      {t("comments.error_boundary.description")}
    </Typography>
    <Button variant="primary" onClick={resetState} size="md">
      {t("comments.error_boundary.try_again")}
    </Button>
    {process.env.NODE_ENV === "development" && error.message && (
      <Typography variant="caption" color="tertiary" component="p">
        {error.message}
      </Typography>
    )}
  </div>
);
